import { StudentList } from './StudentList'
import { StudentShow } from './StudentShow'
import { StudentEdit } from './StudentEdit'

export default {
  list: StudentList,
  show: StudentShow,
  edit: StudentEdit
}
